<template>
  <div class="mt-3">
    <v-form ref="form" class="row">
      <input-text
        v-model="form.simbolo"
        class="col-12 col-md-2"
        :label="$t('modulos.formula.formulario.simbolo')"
        obrigatorio
        :min="1"
        :max="15"
        :disabled="visualizar"
      />
      <input-text
        v-model="form.nome"
        class="col-12 col-md-5"
        :label="$t('modulos.formula.formulario.nome')"
        :min="1"
        :max="500"
        obrigatorio
        trim
        :disabled="visualizar"
      />
      <input-text
        v-model="form.descricao"
        class="col-12 col-md-5"
        :label="$t('modulos.formula.formulario.descricao')"
        :min="0"
        :max="1000"
        :disabled="visualizar"
      />
      <input-unidade-medida
        v-model="form.unidadeMedidaId"
        class="col-12 col-md-3"
        :label="$t('modulos.formula.formulario.unidadeMedida')"
        :multiplos="false"
        obrigatorio
        :disabled="visualizar"
      />
      <input-radio
        v-model="form.flagRequerComponentesIncerteza"
        class="col-12 col-md-3"
        :divider="false"
        :options="opcoes.booleano"
        :label="flagRequerEhObrigatorio"
        :disabled="visualizar"
      />
      <input-radio
        v-model="form.flagDisponivelEmCriteriosAceitacao"
        class="col-12 col-md-2"
        :divider="false"
        :options="opcoes.booleano"
        :label="$t('modulos.formula.formulario.disponivel_criterio_aceitacao')"
        :disabled="visualizar"
      />
      <input-file
        :value="form.fileImagem"
        accept="image/png"
        visualizador
        class="col-12 col-md-4"
        returns="base64"
        :placeholder="$t('geral.inputs.selecione')"
        :label="$t('modulos.formula.formulario.imagem')"
        :regras-personalizadas="[regraArquivo]"
        :disabled="visualizar"
        @clear="desvincularImagem"
        @nome-imagem="nomeImagem"
        @handle-upload="handlerUpload"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="col-12" v-bind="attrs" v-on="!form.id ? on : null">
            <input-ide
              ref="formula"
              v-model="form.formulaTexto"
              :formula-mensurando-id="form.id"
              :label="$t('modulos.formula.formulario.formula')"
              :obrigatorio="!!form.id"
              :disabled="!form.id || visualizar"
              :revisao-id="revisaoId"
              @onValorComMascara="receberValor"
            />
          </div>
        </template>
        <span>
          {{ $t('modulos.formula.tooltip_formula') }}
        </span>
      </v-tooltip>
      <input-textarea
        v-if="form.revisoes.length > 1 || form.numeroRevisao > 0"
        :key="justificativaKey"
        v-model="form.justificativa"
        class="col-12"
        :label="$t('modulos.formula.formulario.justificativa')"
        :min="0"
        :max="500"
        :obrigatorio="justificativaObrigatoria"
        :disabled="visualizar"
      />
      <accordion-padrao
        :titulo="$t('modulos.formula.formulario.variaveis.titulo')"
        :nao-retrair="true"
        class="col-12"
      >
        <tabela-variaveis
          :form="tabela"
          :formula-pai-id="form.id"
          :unidade-medida-pai="form.unidadeMedidaId"
          :desabilitar-tabela="visualizar"
          @tabelaFoiValidada="tabelaFoiValidada"
          @atualizarVariaveisInput="atualizarVariaveisInput"
        />
      </accordion-padrao>
    </v-form>
  </div>
</template>
<script>
import helpers from '@common/utils/helpers';
import { InputUnidadeMedida } from '@components/inputs';
import InputFile from '@components/inputs/InputFile.vue';
import FormulaService from '@common/services/cadastros/FormulaService.js';
import TabelaVariaveis from './TabelaVariaveis.vue';
import { DropdownModel } from '@common/models/geral/DropdownModel';
import { FormulaTabelaModel } from '@common/models/cadastros/FormulaTabelaModel.js';

export default {
  components: {
    InputUnidadeMedida,
    TabelaVariaveis,
    InputFile,
  },
  props: {
    form: {},
    revisaoFormulaId: { type: String, default: '' },
  },
  data() {
    return {
      visualizar: false,
      tabelaValida: false,
      formulaValida: false,
      valido: false,
      justificativaObrigatoria: false,
      justificativaKey: 0,
      opcoes: {
        booleano: helpers.BoleanoEnum,
      },
      error: {
        formulaMensurando: {
          status: false,
          message: '',
        },
      },
      revisaoId: null,
      dados: [],
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'simbolo',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.simbolo'
            ),
            sortable: false,
            width: '120px',
          },
          {
            value: 'unidadeMedidaId',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.unidadeMedida'
            ),
            width: '230px',
            sortable: false,
          },
          {
            value: 'Formula',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.formulaCorrecao'
            ),
            width: '230px',
            sortable: false,
          },
          {
            value: 'descricao',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.descricao'
            ),
            sortable: false,
          },
        ],
      },
    };
  },
  computed: {
    flagRequerEhObrigatorio() {
      return this.$t(
        'modulos.formula.formulario.componentes_incerteza_obrigatorio'
      );
    },
  },
  watch: {
    form() {
      if (!this.form.revisoes.length) {
        return (this.revisaoId = this.revisaoFormulaId);
      } else {
        return (this.revisaoId = this.form.revisoes.filter(
          (el) => el.numeroRevisao == this.form.numeroRevisao
        )[0]?.id);
      }
    },
    'form.formula'() {
      this.formulaValida = false;
    },
    'tabela.dados'() {
      this.form.variaveis = this.tabela.dados;
    },
    async 'form.formulaPaiId'() {
      if (
        typeof this.form.unidadeMedidaId === 'undefined' ||
        !this.form.unidadeMedidaId
      ) {
        await this.selecionarUnidadeMedida();
        this.$forceUpdate();
      }
    },
  },
  mounted() {
    if (
      this.$route.name == 'formula-visualizar' ||
      this.$route.name == 'formula-revisoes-visualizar'
    )
      this.visualizar = true;
  },
  methods: {
    // regraSimbolo(v){
    //   const simboloExistente = this.form.derivadas?.find(p => p.simbolo === v && !p.flagSistema);
    //   if(simboloExistente) return 'Simbolo Existente'
    //   return true;
    // },
    podeJustificativaNula() {
      this.justificativaObrigatoria = false;
      ++this.justificativaKey;
    },

    obrigarPreencherJustificativa: async function () {
      this.toastAlerta(this.$t('modulos.formula.validacoes.justificativa'));
      this.justificativaObrigatoria = true;
      await this.$nextTick();
      this.$refs.form.validate();
    },
    tabelaFoiValidada(e) {
      this.tabelaValida = e;
    },
    async selecionarUnidadeMedida() {
      await FormulaService.buscar(this.form.formulaPaiId.value).then((res) => {
        this.form.unidadeMedidaId = new DropdownModel(res.data.unidadeMedida);
      });
    },
    handlerUpload(file) {
      this.form.imagem = file;
    },
    desvincularImagem() {
      this.form.imagem = null;
      this.form.nomeArquivoImagem = null;
    },
    nomeImagem(nomeImagem) {
      this.form.nomeArquivoImagem = nomeImagem ? nomeImagem : null;
    },
    regraArquivo(v) {
      if (!v) return true;
      if (v?.type == 'image/png') return true;
      return this.$t(`modulos.colaborador.validacoes.permitido_png`);
    },
    atualizarVariaveisInput(removerVariavel) {
      this.$refs['formula'].buscarVariaveis(removerVariavel);
    },
    iniciarTabela: function () {
      this.tabela.dados = [...this.form.variaveis].map((el) => {
        return new FormulaTabelaModel(el);
      });
    },
    recarregarInputFormula() {
      this.$refs['formula'].buscarVariaveis();
    },
    receberValor(valor) {
      this.form.formulaTextoComMascara = valor;
    },
  },
};
</script>

<style lang="scss" scoped>
.adicionarItemTabela {
  color: $color-primary-grey-700;

  &:hover {
    cursor: pointer;
    background: $color-primary-grey-100;
  }
}

.footerTabela {
  background: $color-primary-grey-100;
}
</style>
